import $ from 'jquery';
import { breakpoints } from './_site';
import scrollMonitor from 'scrollMonitor';
require('paroller.js');

export const timeout = {};
export const monitorAnimations = ($monitor) => {
    $monitor.each(function() {
        var $el = $(this),
            watcher,
            offset = $(window).width() < breakpoints.md ? -150 : -250;

        // create monitor
        watcher = scrollMonitor.create($el, offset);

        // watcher.fullyEnterViewport(function () {
        watcher.enterViewport(function() {
            var $el = $(this.watchItem);

            // active section
            $el.addClass('scroll-active');

            // remove listener
            this.destroy();
        });

        $el.data('watcher', watcher);
    });
};
export const binds = () => {
    $('.paroller, [data-paroller-factor]').paroller();
};
